
export default{
    user:{
        codigo: 'sin code',
        email: '',
        loading: false,
    },
    token:'',
    
}


// WEBPACK FOOTER //
// ./src/store/state.js